import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCatalog,
  selectNewTuple,
  selectTypeTables,
  tryCleanCatalog,
  tryGetCatalog,
  tryGetTypeTables,
  tryNewTuple,
} from "../../store/slices/maintenances";
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Card,
  ClickAwayListener,
  Container,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  Grid,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Assignment, MoreHoriz } from "@mui/icons-material";
import ModalMessages from "../layout/modal-messages";
import CustomColumnMenu from "../layout/grid-column-menu";
import TupleAdminDrawer from "./drawer";
import TypeTablesSkeleton from "./skeletons";
import Spinner from "../layout/spinner";
import { DataGrid } from "@mui/x-data-grid";

const TypeTablesEditor = () => {
  const dispatch = useDispatch();

  const isMobile = useMediaQuery("(max-width:600px)");

  //DRAWER ALTA Y EDICION DE TUPLAS
  const [openDrawer, setOpenDrawer] = useState(false);
  const [dataDrawer, setDataDrawer] = useState(undefined);

  //CONTROLA EL MANEJO DE AUTOCOMPLETE
  const [selectedTypeTable, setselectedTypeTable] = useState(null);

  //SETEA SI SE ABRE EL DIALOG
  const [openDialog, setOpenDialog] = useState(false);

  const typeTables = useSelector(selectTypeTables);
  const selectedCatalog = useSelector(selectCatalog);
  const newRow = useSelector(selectNewTuple);

  //MANEJO DE LAS COLUMNAS
  const [rows, setRows] = useState([]);

  //MANEJO ELIMINAR FILA
  const [model, setModel] = useState({});
  const [confirmationDialog, setConfirmationDialog] = useState(false);

  const fetchData = async () => {
    setselectedTypeTable(null);
    setRows([]);
    dispatch(tryGetTypeTables());
    dispatch(tryCleanCatalog());
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    !openDialog &&
      selectedTypeTable &&
      (async () => {
        const action = await dispatch(
          tryGetCatalog(selectedTypeTable.typeTableId)
        );
        if (action.payload.data.data.isValid) {
          setRows(
            action.payload.data.data.data.map((x) => {
              return {
                description: x.description,
                shortDescription: x.shortDescription,
                id: x.id,
              };
            })
          );
        }
      })();
  }, [selectedTypeTable, openDialog]);

  //ELIMINAR UNA TUPLA
  const deleteTuple = async () => {
    const action = await dispatch(tryNewTuple({ model }));
    if (action.payload.data.isValid) {
      setOpenDialog(true);
    }
  };

  //ACCIONES Y COLUMNAS
  const initializeDataGrid = () => {
    return {
      columns: {
        columnVisibilityModel: {
          id: false,
          shortDescription: !isMobile,
          actions: !isMobile,
        },
      },
      pagination: { paginationModel: { pageSize: 10 } },
    };
  };

  //BOTON DE ACCIONES
  const ActionsRow = ({ item }) => {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);

    const handleMenuItemClick = (event, index) => {
      //EDITAR TUPLA
      if (index === 0) {
        setDataDrawer({
          description: item.row.description,
          shortDescription: item.row.shortDescription,
          id: item.row.id,
        });
        setOpenDrawer(true);
      }
      //ELIMINAR TUPLA
      if (index === 1) {
        setModel({
          typeTableId: selectedTypeTable.typeTableId,
          key: item.row.id,
          isDeleted: true,
          isActive: false,
          description: item.row.description,
          shortDesc: item.row.shortDescription,
        });
        setConfirmationDialog(true);
      }

      setOpen(false);
    };

    const handleToggle = () => {
      setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }

      setOpen(false);
    };

    return (
      <>
        <IconButton
          size="small"
          ref={anchorRef}
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="Acciones"
          aria-haspopup="menu"
          onClick={handleToggle}
          sx={{
            padding: "4px",
            backgroundColor: "#225275",
            color: "white",
            borderRadius: "4px",
            "&:hover": {
              backgroundColor: "#173b54",
            },
          }}
        >
          <MoreHoriz />
        </IconButton>

        <Popper
          sx={{ zIndex: 10 }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          placement="left-start"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper elevation={6}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu">
                    <MenuItem
                      key="editTuple"
                      onClick={(event) => handleMenuItemClick(event, 0)}
                    >
                      EDITAR
                    </MenuItem>
                    <MenuItem
                      key="deleteTuple"
                      onClick={(event) => handleMenuItemClick(event, 1)}
                    >
                      ELIMINAR
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    );
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      filterable: false,
      headerClassName: "headRow",
    },
    {
      field: "description",
      headerName: isMobile ? "Detalle del Catálogo" : "DESCRIPCIÓN",
      flex: isMobile ? 1 : 2,
      filterable: false,
      headerClassName: "headRow",
      headerAlign: isMobile ? "center" : "left",
      align: "left",
      renderCell: (params) => {
        if (!isMobile) return <Typography variant="body2">{params.value}</Typography>;

        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              textAlign: "left",
              width: "100%",
              position: "relative",
              py: 1.5,
              pr: 2,
            }}
          >
            <Box sx={{ position: "absolute", right: -8, top: 4 }}>
              <ActionsRow item={params} />
            </Box>

            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 800,
                color: "text.primary",
                mb: 1,
                width: "100%",
              }}
            >
              {params.value}
            </Typography>

            <Typography variant="caption" color="textSecondary" display="block" sx={{ width: "100%" }}>
              Corto: {params.row.shortDescription}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "shortDescription",
      headerName: "DESCRIPCIÓN CORTA",
      headerClassName: "headRow",
      flex: 1,
      filterable: false,
    },
    {
      field: "actions",
      headerAlign: "center",
      headerName: "",
      width: 60,
      minWidth: 60,
      headerClassName: "headRow",
      filterable: false,
      align: "center",
      renderCell: (params) =>
        newRow.isLoading ? (
          <Spinner color="primary" />
        ) : (
          <ActionsRow item={params} />
        ),
    },
  ];

  return (
    <>
      <Container>
        <Grid container spacing={3} sx={{ pt: 3, pb: 3, minWidth: 0 }}>
          <Grid item xs={12} md={6}>
            <Typography
              align="left"
              style={{ fontWeight: "bold", fontSize: 18 }}
              variant="h6"
              component="h1"
            >
              Mantenimiento de Catálogos
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Alert severity="warning" sx={{ textAlign: "left" }}>
              <AlertTitle>ATENCIÓN</AlertTitle>
              Usted está a punto de modificar datos de catálogos del sistema.
              <br />
              <strong>
                NO modifique, elimine, ni agregue registros a un catálogo a
                menos que esté seguro de no afectar el funcionamiento.
              </strong>
            </Alert>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <Autocomplete
                disablePortal={false}
                size="small"
                onChange={(e, newV) => setselectedTypeTable(newV)}
                value={selectedTypeTable}
                loading={typeTables.isLoading}
                options={typeTables?.data || []}
                getOptionLabel={(option) => option.description ?? ""}
                renderInput={(params) => (
                  <TextField {...params} label="Tablas Catálogo" />
                )}
              />
            </FormControl>
          </Grid>

          {selectedCatalog.data.length !== 0 && (
            <>
              {selectedCatalog.isLoading ? (
                <TypeTablesSkeleton />
              ) : (
                <>
                  <Grid item xs={12} md={8}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: { xs: "flex-start", md: "flex-end" },
                        width: "100%",
                      }}
                    >
                      <Button
                        variant="contained"
                        fullWidth={isMobile}
                        endIcon={<Assignment />}
                        onClick={() => {
                          setDataDrawer({
                            description: "",
                            shortDescription: "",
                            id: 0,
                          });
                          setOpenDrawer(true);
                        }}
                      >
                        AGREGAR FILA
                      </Button>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <DataGrid
                      slots={{
                        columnMenu: CustomColumnMenu,
                      }}
                      autoHeight={true}
                      rowSelection={false}
                      getRowId={(row) => row.id}
                      disableRowSelectionOnClick
                      rows={rows}
                      columns={columns}
                      pageSizeOptions={[5, 10, 25, 50]}
                      initialState={initializeDataGrid()}
                      getRowHeight={() => (isMobile ? "auto" : undefined)}
                      getEstimatedRowHeight={() => 100}
                      sx={{
                        "& .MuiDataGrid-virtualScroller": {
                          minHeight: 250,
                        },
                        "& .MuiTablePagination-spacer": {
                          display: isMobile ? "none" : "block",
                        },
                        "& .MuiTablePagination-selectLabel": {
                          display: isMobile ? "none" : "block",
                        },
                        "& .MuiTablePagination-select": {
                          display: isMobile ? "none" : "flex",
                        },
                        "& .MuiDataGrid-footerContainer": {
                          justifyContent: isMobile ? "center" : "flex-end",
                        },
                        "& .MuiTablePagination-toolbar": {
                          justifyContent: isMobile ? "center" : "flex-end",
                          width: isMobile ? "100%" : "auto",
                          paddingLeft: isMobile ? 0 : 2,
                        },
                      }}
                    />
                  </Grid>
                </>
              )}
            </>
          )}
        </Grid>
      </Container>

      {openDrawer && (
        <TupleAdminDrawer
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          setOpenDialog={setOpenDialog}
          description={dataDrawer.description}
          shortDescription={dataDrawer.shortDescription}
          id={dataDrawer.id}
          typeTable={selectedTypeTable.description}
          typeTableId={selectedTypeTable.typeTableId}
        />
      )}

      {confirmationDialog && (
        <Dialog
          open={confirmationDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"¿Confirmas eliminar la fila?"}
          </DialogTitle>
          <DialogActions>
            <Button
              onClick={() => {
                deleteTuple();
                setConfirmationDialog(false);
              }}
              autoFocus
            >
              Aceptar
            </Button>
            <Button onClick={() => setConfirmationDialog(false)} autoFocus>
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {openDialog && (
        <Dialog
          open={openDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"La información ha sido guardada con éxito"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)} autoFocus>
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {typeTables.errors && typeTables.errors.length > 0 && (
        <ModalMessages errors={typeTables.errors} />
      )}
      {selectedCatalog.errors && selectedCatalog.errors.length > 0 && (
        <ModalMessages errors={selectedCatalog.errors} />
      )}
      {newRow.errors && newRow.errors.length > 0 && (
        <ModalMessages errors={newRow.errors} />
      )}
    </>
  );
};

export default TypeTablesEditor;